import { useEffect } from "react";
import { func, string, object } from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { validateUser } from "../../../../api/utils";
import { parseUrl } from "query-string";
import { useGoogleOneTapLogin } from "@react-oauth/google";
import { getCookie } from "../../utils";

const OneTapLogin = ({ member, setMember, redirectURL }) => {
  const qtConfig = useSelector((state) => get(state, ["qt"], {}));
  const currentPath = get(qtConfig, ["currentPath"], "");
  const onLogin = (res) => {
    validateUser(res.credential, redirectURL)
      .then((userData) => {
        setMember(userData.user);
        const params = parseUrl(currentPath);
        const urlParam = get(params, ["query", "url"]);
        const callbackUrl = urlParam !== undefined && urlParam !== null ? urlParam : params?.url;
        if (callbackUrl) {
          const callbackUrlWithToast = `${callbackUrl}?toastMessage=You have successfully Signed In!`;
          window.location.href = callbackUrlWithToast;
        }
      })
      .catch((error) => {
        console.log("Error in one tap login", error);
      });
  };


  useGoogleOneTapLogin({
    onSuccess: (res) => onLogin(res),
    onError: (error) => {
      console.log("one tap Login Failed", error);
    },
    disabled: member,
    cancel_on_tap_outside: false,
    use_fedcm_for_prompt: true,
    use_fedcm_for_button: true,
  });

  return null;
};

OneTapLogin.propTypes = {
  member: object,
  setMember: func.isRequired,
  redirectURL: string,
};

export default OneTapLogin;
